var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVitalsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.977,
    height: 20,
    viewBox: "0 0 19.977 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stethoscope",
    d: "M9.352,8.222a1.111,1.111,0,1,0-.962-1.667H8.241A1.667,1.667,0,0,0,6.574,8.222v5a.518.518,0,0,0-.53.555A6.111,6.111,0,0,0,10.463,19.1v1.343a1.667,1.667,0,0,0,1.111,1.572,4.028,4.028,0,0,0,8.055-.044V19.75a2.083,2.083,0,0,1,4.167,0v1.345a1.667,1.667,0,1,0,1.111,0V19.75a3.194,3.194,0,0,0-6.389,0v2.222a2.917,2.917,0,0,1-5.833.044A1.667,1.667,0,0,0,13.8,20.444V19.1a6.111,6.111,0,0,0,4.419-5.325.518.518,0,0,0-.53-.555v-5a1.667,1.667,0,0,0-1.667-1.667H15.87a1.111,1.111,0,1,0,0,1.111h.149a.556.556,0,0,1,.556.556v5h.116a.622.622,0,0,0-.594.554,4.005,4.005,0,0,1-7.934,0,.622.622,0,0,0-.594-.554h.116v-5a.556.556,0,0,1,.556-.556h.149A1.111,1.111,0,0,0,9.352,8.222Z",
    transform: "translate(-6.042 -6)",
    fill: "#9c8eeb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsIcon);
export default __webpack_public_path__ + "static/media/vitals-icon.f655bba75dd902f3bd3dc2d8732dd606.svg";
export { ForwardRef as ReactComponent };